export function useSelUserHooks(){

  const modalVisible=ref(false);

  const openUseSelWin = function () {
    modalVisible.value=true;
  }

  return {
    modalVisible,
    openUseSelWin
  }
}
